import { BarChart3, ExternalLink } from 'lucide-react';

const DOCS_URL = 'https://posthog.com/docs';

export default function Analytics() {
    const embedUrl = import.meta.env.VITE_POSTHOG_DASHBOARD_EMBED_URL || '';
    const projectUrl = import.meta.env.VITE_POSTHOG_APP_URL || 'https://eu.posthog.com';

    return (
        <div>
            <h1 className="text-3xl font-serif font-bold text-gray-900 mb-2">Analytics</h1>
            <p className="text-gray-600 mb-8 max-w-3xl">
                Trafic réel des visiteurs (hors admin) via PostHog. Le filtrage des bots et du trafic de test se configure
                dans les paramètres du projet PostHog (ingestion, exclusions d’IP, etc.).
            </p>

            {embedUrl ? (
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                    <div className="aspect-[16/10] min-h-[480px] w-full">
                        <iframe
                            title="PostHog — tableau partagé"
                            src={embedUrl}
                            className="w-full h-full border-0"
                            sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
                            referrerPolicy="strict-origin-when-cross-origin"
                        />
                    </div>
                </div>
            ) : (
                <div className="bg-amber-50 border border-amber-200 rounded-xl p-6 text-amber-950 mb-8">
                    <p className="font-medium mb-2">Aucune URL d’intégration configurée</p>
                    <p className="text-sm leading-relaxed">
                        Dans PostHog, ouvrez ou créez un insight / tableau de bord, activez le partage public, puis copiez l’URL
                        d’affichage dans la variable d’environnement <code className="bg-amber-100 px-1 rounded">VITE_POSTHOG_DASHBOARD_EMBED_URL</code> et redéployez.
                    </p>
                </div>
            )}

            <div className="mt-8 flex flex-wrap gap-4">
                <a
                    href={projectUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-5 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 font-medium transition-colors"
                >
                    <ExternalLink size={18} />
                    Ouvrir PostHog
                </a>
                <a
                    href={DOCS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-5 py-3 border border-gray-300 text-gray-800 rounded-lg hover:bg-gray-50 font-medium transition-colors"
                >
                    <BarChart3 size={18} />
                    Documentation PostHog
                </a>
            </div>
        </div>
    );
}
